import cx from 'classnames';
import { renderDesignTokens, useDesignTokens } from '../../theme';
import './Divider.css';
import cn from './Divider.css.json';
import { jsx as _jsx } from "react/jsx-runtime";
export const Divider = props => {
  const dt = useDesignTokens();
  const tokens = {
    ...getDividerDesignTokens(dt, {
      disabled: props.disabled
    }),
    ...props.theme?.(dt)
  };
  return /*#__PURE__*/_jsx("hr", {
    className: cx(cn.divider, props.className),
    style: {
      ...tokens,
      ...props.style
    }
  });
};
export const getDividerDesignTokens = (dt, opts) => {
  return renderDesignTokens({
    bd: opts.disabled ? dt.tokens['color-action-border-standard-disabled'] : dt.tokens['color-container-border-4']
  }, 'divider');
};
//# sourceMappingURL=Divider.js.map